import styled from 'styled-components';

const SectionThreadListEmpty = styled.section``;

export default SectionThreadListEmpty;
